<template>
  <div class="success">
    <!-- <Back /> -->
    <div class="ab-center">
      <img src="@/assets/image/course-success.png" alt="" />
      <p>提交成功</p>
      <div class="btn" @click="handle2LookReport">查看评课报告</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handle2LookReport() {
      const {eventId, formInfoId} = this.$route.query
      if (eventId && formInfoId) {
        this.$router.replace(`/courseReport?formInfoId=${formInfoId}&eventId=${eventId}`)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.success {
  width: 100%;
  height: 100vh;
  background: #f8f9fb;
  text-align: center;

  img {
    width: 200px;
  }
  p {
    color: #a6aaaa;
    font-size: 13px;
  }
  div.btn {
    background: #4465f3;
    border-radius: 40px;
    color: #fff;
    height: 40px;
    line-height: 40px;
  }
}
</style>
